import { Component, computed, inject, input } from '@angular/core';
import { CrntButtonAlt } from '@essent/current-web-angular';
import {
  CoreJssProxyModule,
  ImageField,
  LinkField,
  RichTextField,
  TextField,
} from '@core/jss-proxy';
import { FieldService, GenericLinkDirective } from '@core/jss-utils';
import { RichTextWrapperComponent } from '@legacy/common-ui-utility-components';
import { TrackLinkDirective } from '@analytics/events';

@Component({
  selector: 'wl-product-card',
  standalone: true,
  imports: [
    CoreJssProxyModule,
    CrntButtonAlt,
    GenericLinkDirective,
    RichTextWrapperComponent,
    TrackLinkDirective,
  ],
  templateUrl: './product-card.component.html',
  styleUrls: [
    './product-card.component.ed.scss',
    './product-card.component.essent.scss',
  ],
})
export class ProductCardComponent {
  readonly #fieldService = inject(FieldService);

  readonly title = input.required<TextField>();
  readonly content = input.required<TextField>();
  readonly button1 = input.required<LinkField>();
  readonly button2 = input<LinkField>();
  readonly image = input.required<ImageField>();
  readonly details = input.required<RichTextField>();
  readonly cost = input<TextField>();
  readonly costAddition = input<RichTextField>();

  readonly showCost = computed(() =>
    this.#fieldService.showTextField(this.cost())
  );
  readonly showContent = computed(() =>
    this.#fieldService.showTextField(this.content())
  );
  readonly showDetails = computed(() =>
    this.#fieldService.showTextField(this.details())
  );
  readonly showSecondButton = computed(() =>
    this.#fieldService.showLinkField(this.button2())
  );
}
